import { SeoHead } from "../components/common/SeoHead.tsx";
import { useI18n } from "../i18n/context.tsx";
import { AiCTA } from "../sections/ai/AiCTA.tsx";
import { AiHero } from "../sections/ai/AiHero.tsx";
import { AiModelSelection } from "../sections/ai/AiModelSelection.tsx";
import { BiometricDashboard } from "../sections/ai/BiometricDashboard.tsx";
import { ErrorClassification } from "../sections/ai/ErrorClassification.tsx";
import { EverythingInClassic } from "../sections/ai/EverythingInClassic.tsx";
import { HeartRateTimeline } from "../sections/ai/HeartRateTimeline.tsx";
import { RealtimeAnalytics } from "../sections/ai/RealtimeAnalytics.tsx";
import { VoiceTranscript } from "../sections/ai/VoiceTranscript.tsx";
import { buildJsonLdSoftwareApp, getSeoMeta } from "../utils/seo.ts";

export function AiPage() {
  const { locale } = useI18n();
  const meta = getSeoMeta("ai", locale);
  const jsonLd = buildJsonLdSoftwareApp({
    name: "ShootCreator AI",
    description: meta.description,
    price: "1200",
    priceCurrency: "JPY",
    operatingSystem: "iOS, watchOS",
  });

  return (
    <>
      <SeoHead
        title={meta.title}
        description={meta.description}
        path="/basketball/ai"
        ogImage="/og-ai.png"
        jsonLd={jsonLd}
      />
      <AiHero />
      <EverythingInClassic />
      <ErrorClassification />
      <HeartRateTimeline />
      <RealtimeAnalytics />
      <VoiceTranscript />
      <BiometricDashboard />
      <AiModelSelection />
      <AiCTA />
    </>
  );
}
